import React, { useState } from "react";
import AccountInfo from "../../components/accountInfo/AccountInfo";
import { handlePostRequest } from "../../services/PostTemplate";
import SearchAccountForStatement from "./SearchAccountForStatement";
import { handleGetRequest } from "../../services/GetTemplate";
import DownloadAccountStatement from "./DownloadAccountStatement";
import VerifyOtpAccountStatement from "./VerifyOtpAccountStatement";

function AccountStatementInquiry() {
    const [step, setStep] = useState("SEARCH");
    const [formData, setFormData] = useState(null);
    const [accountData, setAccountData] = useState(null);
    const [accountInfoData, setAccountInfoData] = useState(null);
    const [ocBalance, setOcBalance] = useState(null);

    const handleReturnData = (data, formData) => {
        setAccountInfoData(data?.data);
        setFormData(formData);
        if (data?.data === undefined) {
            setStep("SEARCH");
        }
        else {
            setStep("VERIFY_OTP");
        }
    };

    const onVerifyOtp = async (otp) => {
        const data = {
            ...formData,
            otp: otp,
        };
        try {
            const res = await handlePostRequest(data, "zbizgateway/accountMaintainence/accountStatement");
            setAccountData(res.data?.AccountStatement);
            setStep("SHOW_ACCOUNT_STATEMENT");
            if (res?.responsecode === 1) {
                const res = await handleGetRequest(`zbizgateway/accountMaintainence/openingAndClosingBalance/${formData?.mobileNo}`)
                setOcBalance(res?.data)
            }
        } catch (error) {
            console.log(error);
        }
    };

    switch (step) {
        case "SEARCH":
            return <SearchAccountForStatement title="Account Statement" handleReturnData={handleReturnData} api="zbizgateway/accountMaintainence/accountStatementInquiry" />;
        case "VERIFY_OTP":
            return (
                <>
                    <SearchAccountForStatement title="Account Statement" handleReturnData={handleReturnData} api="zbizgateway/accountMaintainence/accountStatementInquiry" />
                    <AccountInfo accountInfoData={accountInfoData} />
                    <VerifyOtpAccountStatement onVerifyOtp={onVerifyOtp} />
                </>
            );
        case "SHOW_ACCOUNT_STATEMENT":
            return (
                <>
                    <SearchAccountForStatement title="Account Statement" handleReturnData={handleReturnData} api="zbizgateway/accountMaintainence/accountStatementInquiry" />
                    <AccountInfo accountInfoData={accountInfoData} />
                    <DownloadAccountStatement formData={formData} />
                    {/* <AccountStatementInquiryData accountData={accountData} accountInfoData={accountInfoData} formData={formData} ocBalance={ocBalance} /> */}
                </>
            );

        default:
            return null;
    }
}

export default AccountStatementInquiry;
